// extracted by mini-css-extract-plugin
module.exports = {"Subscribe":"Subscribe_Subscribe__IRQEx"};